export var primary = "#0153a3"
export var primaryLight = "#0153a3"
export var primaryDark = "#0153a3"
export var secondary = "#1e8dfa"
export var inheritDefault1 = "#fefefe"
export var inheritDefault2 = "#f8f9ff"
export var bgLight = "#e8e7ea"
export var bgDark = "#212325"
export var bgElementsLight = "#d5d5d5"
export var bgElementsDark = "#1e2e3a"
export var second = "#070919"
export var indigo = "#7420ff"
export var purple = "#793de6"
export var pink = "#fc26a4"
export var red = "#f83245"
export var orange = "#f4772e"
export var yellow = "#ffc926"
export var green = "#1bc943"
export var teal = "#18e1a5"
export var cyan = "#27dcf3"
export default {"primary":"#0153a3","primaryLight":"#0153a3","primaryDark":"#0153a3","secondary":"#1e8dfa","inheritDefault1":"#fefefe","inheritDefault2":"#f8f9ff","bgLight":"#e8e7ea","bgDark":"#212325","bgElementsLight":"#d5d5d5","bgElementsDark":"#1e2e3a","second":"#070919","indigo":"#7420ff","purple":"#793de6","pink":"#fc26a4","red":"#f83245","orange":"#f4772e","yellow":"#ffc926","green":"#1bc943","teal":"#18e1a5","cyan":"#27dcf3"}
